import { render } from "./PdfLink.vue?vue&type=template&id=6eb56d8f&scoped=true"
import script from "./PdfLink.vue?vue&type=script&lang=js"
export * from "./PdfLink.vue?vue&type=script&lang=js"

import "./PdfLink.vue?vue&type=style&index=0&id=6eb56d8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eb56d8f"]])

export default __exports__